export const useMeta = (meta: { title: string, description: string }) => {
    useHead({
      title: `${meta.title} | SK Jewellery`,
      meta: [
        { name: 'description', content: meta.description }
      ]
    })
  }
export const useSingleMeta = (meta: { priceAmount: string, priceCurrency: string }) => {
  useHead({
    meta: [
      { property: 'product:price:amount', content: meta.priceAmount },
      { property: 'product:price:currency', content: meta.priceCurrency }
    ]
  })
}